/* eslint-disable react/prop-types */
import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const LeagueCard = loadable(() => pMinDelay(import('./LeagueCard'), 300), {
  fallback: <Loading />
});

const AsyncLeagueCard = props => {
  const metaConfiguration = props.metaConfiguration['/lig-karti'];
  const title = metaConfiguration?.title;
  const meta = metaConfiguration.meta;
  const pageConfig = {
    headerType: 'full',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green hide-betslip hide-sticky-navigation`
      },
      title,
      meta
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <LeagueCard { ...props }/>
    </ApplicationLayout>
  );
};

AsyncLeagueCard.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLeagueCard;
